import React from "react";
import "./AppHeader.css";
import Icon from "./Icon";

export default function AppHeader({
  searchValue,
  onSearchChange,
  onSearchSubmit,
  onBrandClick,
  searching,
}) {
  const hasSearchValue = searchValue.length > 0;

  return (
    <header className="app-header glass-panel">
      <button className="brand" type="button" onClick={onBrandClick} aria-label="Recargar Movie Time">
        <img src="/img/MovieTime.png" alt="Movie Time" className="brand-logo" />
        <div>
          <h1 className="brand-title">Movie Time</h1>
          <p>Descubre películas, trailers y tus favoritos</p>
        </div>
      </button>

      <form className="search-form" onSubmit={onSearchSubmit}>
        <div className={`search-input-wrapper ${hasSearchValue ? "has-value" : ""}`}>
          <Icon name="search" className="search-icon" size={18} />
          <input
            type="text"
            value={searchValue}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Buscar películas..."
            aria-label="Buscar películas"
          />
          {hasSearchValue ? (
            <button
              type="button"
              className="search-clear"
              onClick={() => onSearchChange("")}
              aria-label="Limpiar búsqueda"
            >
              <Icon name="close" size={14} />
            </button>
          ) : null}
        </div>
        <button type="submit" className="btn btn-primary" disabled={searching}>
          {searching ? (
            <>
              <span className="btn-spinner" aria-hidden="true" />
              Buscando...
            </>
          ) : (
            <>
              <Icon name="search" size={16} />
              Buscar
            </>
          )}
        </button>
      </form>
    </header>
  );
}
